module.exports = __webpack_public_path__ + "img/locker-front-icon-disabled.a5b11d47.svg";